<template>
    <div class="mbody">
        <h1 style="justify-content: center;display: flex;">Heists</h1>

        <hr class="rounded">

        <div style="text-align: center;color: red;"  v-if="$store.state.wallet_manager == undefined">Please download a wallet</div>
        
        <div style="justify-content: center;display: flex;" v-show="Object.keys($store.state.nfr_manager.nfrs).length == 0">&lt; no
            running heists &gt;</div>

        <CoalHeistItemVue class="nfrholderouter" v-for="(wrkrv, wrkk, widx) in $store.state.nfr_manager.nfrs" :key="widx"
            style="display:block;border-style: solid;" v-bind:id="'minele-' + wrkrv.nft.id" :heistItem="wrkrv"
            :wrkk="wrkk">

        </CoalHeistItemVue>
    </div>
</template>

<script>

import ENUMS from '../Enums';
import CoalHeistItemVue from './CoalHeistItem.vue'

export default {
    name: ENUMS.VIEWS.HEISTS
    , data() {
        return {
            ENUMS: ENUMS

        }
    }
    , mounted() {
        if (this.$store.state.nfr_cur > -1) {
            setTimeout(() => {

                document.getElementById('minele-' + this.$store.state.nfr_cur).scrollIntoView()
            }, 100);
        }
    }
    , methods: {

    }, components: {
        CoalHeistItemVue
    }
}

</script>
<style scoped>
.nfrholderouter {
    /* display: flex;
    justify-content: space-around;
    flex-direction: column; */
    /* flex-wrap: wrap; */
    align-items: center;
    /* margin-right: 5%; */
    margin-top: 10%;
    overflow: hidden;
}
</style>